import { render, staticRenderFns } from "./scanCouponCode.vue?vue&type=template&id=4686c009&scoped=true"
import script from "./scanCouponCode.vue?vue&type=script&lang=js"
export * from "./scanCouponCode.vue?vue&type=script&lang=js"
import style0 from "./scanCouponCode.vue?vue&type=style&index=0&id=4686c009&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4686c009",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4686c009')) {
      api.createRecord('4686c009', component.options)
    } else {
      api.reload('4686c009', component.options)
    }
    module.hot.accept("./scanCouponCode.vue?vue&type=template&id=4686c009&scoped=true", function () {
      api.rerender('4686c009', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/scanCouponCode/scanCouponCode.vue"
export default component.exports